import React from "react";
import FacebookSosmed from "./FacebookSosmed";

const FacebookMain = () => {
  return (
    <section id="facebook" className="pt-0">
      <div className="">
        <FacebookSosmed />
      </div>
    </section>
  );
};

export default FacebookMain;
